import { ExternalLink } from "lucide-react";

export const Footer = () => (
  <footer
    data-testid="footer-bridge-section"
    className="relative border-t border-amber-500/15 py-14 px-6"
  >
    <div className="max-w-2xl mx-auto text-center">
      <p className="font-serif-display text-2xl gold-text font-semibold">S · T</p>
      <p data-testid="footer-couple-blessing-note" className="text-sm text-zinc-400 mt-4">
        For Mata Ki Chowki &amp; The Royal Wedding celebrations — Sunday, 22nd November 2026 —
        visit our wedding website
      </p>
      <a
        data-testid="footer-link-main-wedding-site"
        href="https://sarnishka.buzz"
        target="_blank"
        rel="noopener noreferrer"
        className="btn-outline-gold rounded-full px-7 py-2.5 text-sm font-semibold inline-flex items-center gap-2 mt-6"
      >
        sarnishka.buzz <ExternalLink className="w-4 h-4" />
      </a>
      <p className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-zinc-500 mt-10">
        #SARNISHKA · New Delhi
      </p>
    </div>
  </footer>
);
